import { skipToken } from "@reduxjs/toolkit/query";

import { useAppSelector } from "~/app/store";
import { selectWorkstationAutostoreGridId } from "~/redux/selectors/workstationsSelectors";
import { useGetAutostoreGridQuery } from "~/redux/warehouse/autostoreGrid.hooks";

/**
 * Helper which fetches the current workstation's grid and returns:
 * - Whether the grid has multiple temperature zones
 * - The list of temperature zones
 */
export function useGetMultiTempGridInfo() {
  const gridId = useAppSelector(selectWorkstationAutostoreGridId);
  const { data: autostoreGrid } = useGetAutostoreGridQuery(gridId ?? skipToken);

  const tempZones = autostoreGrid?.temperatureZones ?? [];
  const isMultiTempGrid = tempZones?.length > 1;

  return { isMultiTempGrid, tempZones };
}
